<template>
    <div :class="`main-footer ${layoutType}-type`">
        <div class="wrapper">
            <div class="con-wrapper">
                <div class="row">
                    <div class="col-xs-4 logo-con">
                        <router-link :to="{ name: 'home' }">
                            <img class="img-responsive" :src="`${icdn_url}/desktop-logo.png`" :alt="`Logo ${site_name}`" v-cloak>
                        </router-link>
                        <p v-html="footerText" />
                        <div class="gateway-icons">
                            <img class="mastercard" :src="`${cdn_url}/images/footer-icons/mastercard.png`" alt="mastercard">
                            <img class="visa" :src="`${cdn_url}/images/footer-icons/visa-blue.png`" alt="visa">
                        </div>
                    </div>
                    <div class="col-xs-2 info-con">
                        <base-menu class="sub-menu" :menu="sub_menu_1"></base-menu>
                    </div>
                    <div class="col-xs-2 more-info-con">
                        <base-menu class="sub-menu" :menu="sub_menu_2"></base-menu>
                    </div>
                    <div class="col-xs-4">
                        <div v-if="layoutType == 'home'" class="social-con">
                            <template v-for="(item, key) in social_icons">
                                <a :href="item.link" class="social-icon" :key="key" target="_blank">
                                    <i :class="`icon ${item.icon}`"></i>
                                </a>
                            </template>
                        </div>
                        <div v-else class="cp-txt-con">
                            <p>Copyright © {{ current_year }} <b>{{ site_name }}</b> {{ 'All rights reserved.' | translate }}</p>
                        </div>
                    </div>
                    <div class="col-xs-12" v-if="!hide_address">
                        <div class="address-icon long-address">
                            <img class="address" :src="footer_address" alt="address">
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="layoutType == 'home'" class="cp-con">
                <div class="con-wrapper btm-txt">
                    <div class="footer-logo">
                        <img class="img-responsive" :src="`${icdn_url}/desktop-footer-logo.png`" :alt="`White logo ${site_name}`" v-cloak>
                    </div>
                    <div class="cp-txt">
                        <p>Copyright © {{ current_year }} <b>{{ site_name }}</b> {{ 'All rights reserved.' | translate }}</p>
                    </div>
                    <div class="credit-txt">
                        <p>Don't forget to give credit</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="city_pages.length" class="wrapper below">
            <div class="con-wrapper">
                <div class="row">
                    <div class="city-page-link col-xs-3" v-for="page in city_pages" :key="page.id">
                        <a :href="`${origin}/${page.url}`">{{ limitLinkText(page.title) }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MainFooter from '@views/common/MainFooter/main_footer'
    import BaseMenu from '@theme-views/common/BaseMenu'

    export default {
        mixins: [MainFooter],
        components: {
            BaseMenu
        },
        data() {
            return {
                social_icons: [
                    {
                        icon: 'icon-social-ig',
                        link: '#',
                    },
                    {
                        icon: 'icon-social-fb',
                        link: '#',
                    },
                    {
                        icon: 'icon-social-tw',
                        link: '#',
                    },
                ]
            }
        },
        props: {
            layoutType: {
                type: String,
                default: 'default'
            }
        }
    }
</script>

<style lang="scss" src="./main_footer.scss"></style>
